import { f as r } from "../internals/function-uncurry-this.js";
import { a } from "../internals/array-buffer-view-core.js";
import { a as i } from "../internals/array-copy-within.js";
var t = r(i),
  n = a.aTypedArray;
(0, a.exportTypedArrayMethod)("copyWithin", function (r, a) {
  return t(n(this), r, a, arguments.length > 2 ? arguments[2] : void 0);
});